import { BaseDataModel } from "@domain/BaseDataModel";

export class LabTest extends BaseDataModel {
	name: string = "";
	labName: string = "";
}
